import React from 'react';
import { SmallSemiBoldTypography, SmallTypography } from 'patient-ping-remedy/packages/typography';
import {Roster, User} from '@/api/dto/dto';
import Avatar from '@common/Avatar';
import {Wrapper, UserDetailsWrapper} from '@common/PopoverAvatarDetails.styles';

type Props = {
    user: Partial<User>;
    roster?: Roster | null;
}

const PopoverAvatarDetails = (props: Props) => {
  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <Avatar user={props.user} />
      <UserDetailsWrapper>
        <SmallSemiBoldTypography>
          {props.user.first_name} {props.user.last_name} {props.user.deleted ? '(Deleted)' : ''}
        </SmallSemiBoldTypography>
        {props.user.title && <SmallTypography>{props.user.title}</SmallTypography>}
        {props.roster && <SmallTypography>{props.roster.name}</SmallTypography>}
        <SmallTypography>{props.user.email}</SmallTypography>
      </UserDetailsWrapper>
    </Wrapper>
  );
};

export default PopoverAvatarDetails;
